export default __webpack_public_path__ + "static/media/slide1-sk.dd5fd47c.jpg";